import { useCallback as c } from "react";
import { useAuth as f } from "react-oidc-context";
import { addEventToDataLayer as i } from "../services/gtm.js";
import { useAnonymousId as I } from "./use-anonymous-id.js";
const p = () => {
  var e, n;
  const { anonymousId: t } = I(), s = f(), o = ((n = (e = s == null ? void 0 : s.user) == null ? void 0 : e.profile) == null ? void 0 : n.sub) ?? "";
  return { trackEvent: c(
    ({ event: m, payload: r }) => {
      const u = (r == null ? void 0 : r.userId) ?? o;
      i({
        event: m,
        payload: {
          ...r,
          anonymousId: t,
          ...u && { userId: u }
        }
      });
    },
    [t, o]
  ) };
};
export {
  p as useGTM
};
